import { RailTrackResponseDto } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { TomAutoComplete } from '@tom-ui/ui'
import { useEffect, useMemo } from 'react'

interface IProps {
  label: string
  value?: string
  onChange: (railTrackId?: string) => void
  options: RailTrackResponseDto[]
  hasError: boolean
  required?: boolean
  disabled?: boolean
}

const RailTrackAutocomplete = ({
  label,
  options,
  value,
  onChange,
  hasError,
  required,
  disabled,
}: IProps) => {
  const { t } = useTranslate()

  const singleOption = options.length === 1 ? options[0] : null

  useEffect(() => {
    if (singleOption) {
      onChange(singleOption.id)
    }
  }, [singleOption, onChange])

  const resolvedValue = useMemo(() => {
    return singleOption ?? options.find(x => x.id === value)
  }, [singleOption, options, value])

  return (
    <TomAutoComplete<RailTrackResponseDto>
      label={label}
      options={options}
      defaultValue={resolvedValue}
      getOptionLabel={railTrack => railTrack.name}
      entityKey='id'
      onChangeEntity={entity => {
        onChange(entity?.id)
      }}
      error={hasError}
      helperText={hasError ? t('fieldIsRequired', 'Field is required') : undefined}
      disabled={disabled || !!singleOption}
      dataCy='rail-track-autocomplete'
      required={required}
    />
  )
}

export default RailTrackAutocomplete
